import Loader from 'components/Loader'

export const CoursesCardLoader = () => (
  <Loader width={340} height={195}>
    <rect x={0} y={0} width="100%" height="100%" rx={8} ry={8} />
  </Loader>
)

export const ListLoader = () => (
  <>
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
    <CoursesCardLoader />
  </>
)
